// Singleton class to manage text-to-speech functionality
class SpeechManager {
  constructor() {
    this.speaking = false;
    this.initialized = false;
    this.voice = null;
    this.lastSpeakTime = 0;
    this.minTimeBetweenSpeak = 500; // ms
    
    // Handle voice loading
    if ('speechSynthesis' in window) {
      // Only initialize once voices are loaded
      window.speechSynthesis.onvoiceschanged = () => {
        if (!this.initialized) {
          this.initialize();
        }
      };
    }
  }

  initialize() {
    if (!('speechSynthesis' in window) || this.initialized) return;
    
    // Get available voices
    const voices = window.speechSynthesis.getVoices();
    if (voices.length === 0) return; // Wait for voices to load
    
    // Try to find a male English voice
    this.voice = voices.find(v => v.lang.includes('en') && (v.name.includes('Male') || v.name.includes('David'))) || voices[0];

    this.initialized = true;
  }
speak(text) {
  if (!('speechSynthesis' in window) || !text) return;
  
  const now = Date.now();
  if (now - this.lastSpeakTime < this.minTimeBetweenSpeak) {

    return;
  }
  
  // Initialize if needed
  if (!this.initialized) {
    this.initialize();
  }

  // Cancel any ongoing speech and clear the queue
  window.speechSynthesis.cancel();
  
  const utterance = new SpeechSynthesisUtterance(text);
  
  // Configure voice for robotic effect
  utterance.rate = 0.85;
  utterance.pitch = 0.001;
  if (this.voice) utterance.voice = this.voice;

  // Track speaking state
  utterance.onstart = () => {

    this.speaking = true;
    this.lastSpeakTime = now;
  };
  utterance.onend = () => {

    this.speaking = false;
  };
  utterance.onerror = (event) => {
    console.error('Speech error:', event);
    this.speaking = false;
  };

  // Speak immediately without any delay
  window.speechSynthesis.speak(utterance);
}

  stop() {
    if ('speechSynthesis' in window) {
      window.speechSynthesis.cancel();
      this.speaking = false;
    }
  }

  isSpeaking() {
    return this.speaking;
  }
}

// Export singleton instance
export default new SpeechManager();